import { useEffect, useState } from 'react'

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Wait for both document ready and styles to be loaded
    const hidePreloader = () => {
      // Add loaded class to root for smooth transition
      const root = document.getElementById('root')
      if (root) {
        root.classList.add('loaded')
      }

      // Give extra time for CSS to fully apply
      setTimeout(() => {
        if (typeof window.$ === 'function') {
          window.$(".loader").fadeOut("slow")
        } else {
          setIsLoading(false)
        }
      }, 300)
    }

    // Check if document is already loaded
    if (document.readyState === 'complete') {
      hidePreloader()
    } else {
      window.addEventListener('load', hidePreloader)
      return () => window.removeEventListener('load', hidePreloader)
    }
  }, [])

  if (!isLoading && typeof window.$ !== 'function') return null

  return (
    <div className="loader center-block">
      <div className="loader-spinner" />
    </div>
  )
}

export default Preloader